import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "dropdown"]
  dropdownVisible = false

  connect() {
    document.addEventListener('click', this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  filter(event) {
    const query = event.target.value.toLowerCase()
    this.itemTargets.forEach(item => {
      const value = item.dataset.value
      if (value.includes(query)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropdownVisible = !this.dropdownVisible
    this.dropdownTarget.classList.toggle('hidden', !this.dropdownVisible)
  }

  handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this.dropdownVisible = false
      if (this.hasDropdownTarget) {
        this.dropdownTarget.classList.add('hidden')
      }
    }
  }
}
